module.exports = __webpack_public_path__ + "img/weft_pick.d2effc23.svg";